module.exports = __webpack_public_path__ + "img/step2-1.1b3ab053.png";